<script setup lang="ts">
import { FormKitLazyProvider } from '@formkit/vue'
import type { Schemas } from '@shopware/api-client/api-types';

const props = defineProps<{
    element: Schemas['CmsSlot'];
}>();

const elementConfig = useCmsElementConfig(props.element);
const { getCmsLink } = useFormatCmsLink();
const { getMedia, getSpecificMedia } = useGetMedia();

const headline = elementConfig.getConfigValue('headline');
const description = elementConfig.getConfigValue('description');
const buttonText = elementConfig.getConfigValue('button');
const buttonLink = await getCmsLink(elementConfig.getConfigValue('buttonUrl'));
const manufacturerLink = await getCmsLink(elementConfig.getConfigValue('manufacturerUrl'));
const imageId = elementConfig.getConfigValue('manufacturer');
const { data: medias } = await getMedia([imageId]);
const manufacturerImage = getSpecificMedia(imageId, medias.value);
</script>

<template>
    <div>
        
<FormKitLazyProvider config-file="true">
<LocaleLink
            v-if="manufacturerLink && manufacturerImage"
            :to="manufacturerLink"
            class="block max-w-max"
        >
            <img
                v-if="manufacturerImage"
                :src="manufacturerImage.url"
                :alt="manufacturerImage.alt"
                class="mb-4 h-10 object-contain"
            />
        </LocaleLink>

        <img
            v-else-if="manufacturerImage"
            :src="manufacturerImage.url"
            :alt="manufacturerImage.alt"
            class="mb-4 h-10 object-contain"
        />

        <h2
            v-if="headline"
            class="text-xl font-extrabold md:text-3xl"
        >
            {{ headline }}
        </h2>

        <p
            v-if="description"
            class="mt-2"
        >
            {{ description }}
        </p>

        <LocaleLink
            v-if="buttonText && buttonLink"
            :to="buttonLink"
            class="block max-w-max"
        >
            <FormKit
                type="button"
                :label="buttonText"
                :classes="{
                    input: 'font-bold text-md mt-6',
                }"
            />
        </LocaleLink>
</FormKitLazyProvider>

    </div>
</template>
